/**
 * Sets `document.title` for the lifetime of the calling component.
 *
 * Restores the previous title on unmount so that lazy-loaded subtrees that
 * unmount don't leave a stale title behind. Format is `<page> — Polygraf Online`
 * to keep the brand visible without dominating the tab.
 */

import { useEffect } from 'react'

const APP_NAME = 'Polygraf Online'

export function usePageTitle(title: string | null | undefined): void {
	useEffect(() => {
		const previous = document.title
		document.title = title ? `${title} — ${APP_NAME}` : APP_NAME
		return () => {
			document.title = previous
		}
	}, [title])
}
